import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-blog',
    imports: [],
    templateUrl: './blog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './blog.component.scss'
})
export class BlogComponent {

}
